import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormGroup, ReactiveFormsModule,FormArray } from '@angular/forms';
import { DynamicFieldConfig, DynamicFormLayout, UiSection } from '../../../core/models/dynamic-form.models';
import { DynamicFieldComponent } from '../dynamic-field/dynamic-field';
import { LineItemsTableComponent } from '../../../partials/components/renderers/line-items-table/line-items-table';
@Component({
  selector: 'app-dynamic-section',
  standalone: true,
  // changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ReactiveFormsModule, LineItemsTableComponent, DynamicFieldComponent],
  templateUrl: './dynamic-section.html'
})
export class DynamicSectionComponent {
  @Input() section!: UiSection;
  @Input() layout!: DynamicFormLayout;
  @Input() form!: FormGroup;
  columnCache: Record<string, DynamicFieldConfig[]> = {};

  trackRow(
    index: number,
    row: any  
  ) {

    return row?.__uid ??
          row?.id ??
          index;
  }
  trackField = (_: number, field: any) => field.id || field.name;

  getColumnsFor(
    parent: string
  ): DynamicFieldConfig[] {

    if (
      this.columnCache[parent]
    ) {
      return this.columnCache[parent];
    }

    this.columnCache[parent] =
      Object.values(
        this.layout.fieldsMap
      )

      .filter(
        (f: DynamicFieldConfig) =>
          f.parentField === parent
      )

      .filter(
        (f: DynamicFieldConfig) =>
          f.type !== 'hidden'
      )

      .sort(
        (a, b) =>
          (a.seq ?? 0) -
          (b.seq ?? 0)
      );

    return this.columnCache[parent];
  }

  getFormArray(name:string):FormArray{
    return this.form.get(name) as FormArray;
  }

  getFieldColSpan(fieldCount: number): string {
    // Mobile: Always full width (col-span-12)
    // Tablet (md): 2 or 3 fields per row
    // Desktop (lg): High-density grid logic
    switch (fieldCount) {
      case 1:
        return 'lg:col-span-12 md:col-span-12';
      case 2:
        return 'lg:col-span-6 md:col-span-6';
      case 3:
        return 'lg:col-span-4 md:col-span-6';
      case 4:
        return 'lg:col-span-3 md:col-span-6';
      case 5:
        return 'lg:col-span-2 md:col-span-4'; // Occupies 10/12 columns
      case 6:
        return 'lg:col-span-2 md:col-span-4'; // Occupies 12/12 columns (perfect)
      case 7:
        // For 7 fields, span 1 is too tiny. Span 2 will wrap the 7th field 
        // to a new line automatically, which is safer for UI clarity.
        return 'lg:col-span-1 md:col-span-3'; // Use span 1 ONLY if inputs are very small (like checkboxes)
      default:
        // High density fallback
        return 'lg:col-span-2 md:col-span-4';
    }
  }
}